import { Message, SendFile } from "../../models/Message";
import { MyNotifs } from "../../services/MyNotifs";

export class UIMessage {
  sendFiles: File[] = [];
  isLocal: boolean = false;
  isNewDay: boolean = false;

  constructor(public msg: Message, public children: UIMessage[]) {
  }

  replyCount: number = 0;
  lastReply: Message | null = null;
  repliesLoaded: boolean = false;
  unreadReplyCount: number = 0;

  isNew() {
    return MyNotifs.NotificationsByMessage.get(this.msg.id)?.isNew ?? false;
  }

  // setOpened(value: boolean) {
  //   this.opened = value;
  //   if(value) {
  //     Current.MessageReadStatus.set(this.msg.id, true);
  //   } else {
  //     Current.MessageReadStatus.delete(this.msg.id);
  //   }
  // }
  nonReactions(): UIMessage[] {
    return this.children.filter(c => !c.msg.emoticon);
  }

  reactions(): UIMessage[] {
    const reactionMap = new Map<string, UIMessage>();

    this.children.filter(c => c.msg.emoticon).forEach(c => {
      const userId = c.msg.user?.id;
      if (!userId) return;

      const existing = reactionMap.get(userId);
      if (!existing) {
        reactionMap.set(userId, c);
      } else {
        // 더 최신 데이터로 교체 (created 시간이 같거나 더 크면 교체)
        const newTime = new Date(c.msg.created).getTime();
        const oldTime = new Date(existing.msg.created).getTime();
        // 로컬에서 방금 생성한 메시지는 created가 현재 시간이므로 가장 최신일 것임
        if (newTime >= oldTime) {
          reactionMap.set(userId, c);
        }
      }
    });

    return Array.from(reactionMap.values());
  }

  /**
   * 불변성을 유지하면서 자식 메시지를 추가한 새 UIMessage 반환
   */
  withChild(child: UIMessage): UIMessage {
    const newMsg = new UIMessage(this.msg, [...this.children, child]);
    newMsg.replyCount = this.replyCount + 1;
    newMsg.lastReply = child.msg;
    newMsg.repliesLoaded = this.repliesLoaded;
    newMsg.isNewDay = this.isNewDay;
    newMsg.unreadReplyCount = this.unreadReplyCount;
    newMsg.sendFiles = this.sendFiles;
    newMsg.isLocal = this.isLocal;
    return newMsg;
  }

  /**
   * 불변성을 유지하면서 children을 교체한 새 UIMessage 반환
   */
  withChildren(children: UIMessage[]): UIMessage {
    const newMsg = new UIMessage(this.msg, children);
    newMsg.replyCount = children.filter(c => !c.msg.emoticon).length;
    newMsg.lastReply = children.length > 0 ? children[children.length - 1].msg : null;
    newMsg.repliesLoaded = true;
    newMsg.isNewDay = this.isNewDay;
    newMsg.unreadReplyCount = this.unreadReplyCount;
    newMsg.sendFiles = this.sendFiles;
    newMsg.isLocal = this.isLocal;
    return newMsg;
  }
}


